import NetworkUtil from "./NetworkUtil";
import { ServerResponse } from "../types/ServerResponse";
import { MetaDataMethodCode } from "../types/MetaDataMethodCode";

export default class MethodCodeAPI {

  public static async getAllMethodCodes(): Promise<{ success: boolean, reason: string, data }> {
    return NetworkUtil.makeGet("/api/admin/methodcodes");
  }

  public static async filterMethodCodes(filter: { filter: { Name?, Description?, Active? } }): Promise<{ success: boolean, reason: string, data }> {
    return NetworkUtil.makePost("/api/admin/methodcodes/filter", filter)
  }

  public static async createMethodCode(methodcode: MetaDataMethodCode): Promise<ServerResponse> {
    return NetworkUtil.makePost("/api/admin/methodcodes/create", methodcode)
  }

  public static async editMethodCode(methodcode: MetaDataMethodCode): Promise<ServerResponse> {
    return NetworkUtil.makePost("/api/admin/methodcodes/edit", methodcode)
  }

}